const setBackgroundStyle = (image, fit = 'cover') => ({
  background: `url(${image}) center center /${fit} no-repeat`,
})

export default setBackgroundStyle
